import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi';
import Button from 'common/components/button';
import { iconPositionEnum } from 'common/utils/enums';

const ApplyButtons = ({
  onBackClick,
  onNextClick,
  handleSubmit,
  moveOn,
  loading,
  isValid,
  disableBack = false,
  disableNext = false,
  fullHeight = false,
  backTitle = 'Back',
  nextTitle = 'Next',
  children
}) => {
  return (
    <div className='fixed bottom-0 inset-x-0 flex justify-end gap-4 bg-white border-t border-gray-200 py-4 px-6 lg:static lg:gap-3 lg:items-start lg:border-none lg:p-0 z-30' >
      <Button
        disabled={disableBack}
        onClick={onBackClick}
        Icon={BiLeftArrowAlt}
        iconPosition={iconPositionEnum.LEFT}
        theme='secondary'
        title={backTitle}
        className={disableBack ? 'hidden' : 'pr-6'}
        wFull={false}
      />
      {children}
      <Button
        loading={loading}
        disabled={loading || !isValid || disableNext}
        onClick={moveOn ? onNextClick : handleSubmit}
        Icon={BiRightArrowAlt}
        title={nextTitle}
        className={disableNext ? 'hidden' : 'pl-6'}
        wFull={false}
      />
    </div>
  );
};

export default ApplyButtons;
